function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { arrayOf, string } from 'prop-types';
import { Hyperlink, SocialIcons } from '../..';
import { ProfileLinksList, iconStylesCommon, behanceStyles, dribbleStyles, facebookStyles, instagramStyles, linkedinStyles, twitterStyles, githubStyles } from './ProfilesLinks.styles';
export const ProfileLinks = _ref => {
  let {
    links
  } = _ref;
  const renderSocialIcon = link => {
    if (link.includes('linkedin.com')) {
      return /*#__PURE__*/React.createElement(SocialIcons, _extends({
        type: "linkedin"
      }, linkedinStyles));
    }
    if (link.includes('dribbble.com')) {
      return /*#__PURE__*/React.createElement(SocialIcons, _extends({
        type: "dribbble"
      }, dribbleStyles));
    }
    if (link.includes('facebook.com')) {
      return /*#__PURE__*/React.createElement(SocialIcons, _extends({
        type: "facebook"
      }, facebookStyles));
    }
    if (link.includes('behance.net')) {
      return /*#__PURE__*/React.createElement(SocialIcons, _extends({
        type: "behance"
      }, behanceStyles));
    }
    if (link.includes('twitter.com')) {
      return /*#__PURE__*/React.createElement(SocialIcons, _extends({
        type: "twitter"
      }, twitterStyles));
    }
    if (link.includes('github.com')) {
      return /*#__PURE__*/React.createElement(SocialIcons, _extends({
        type: "github"
      }, githubStyles));
    }
    if (link.includes('instagram.com')) {
      return /*#__PURE__*/React.createElement(SocialIcons, _extends({
        type: "instagram"
      }, instagramStyles));
    }
    if (link.includes('instagram.com')) {
      return /*#__PURE__*/React.createElement(SocialIcons, _extends({
        type: "instagram"
      }, instagramStyles));
    }
    return /*#__PURE__*/React.createElement(SocialIcons, _extends({
      type: "website"
    }, iconStylesCommon));
  };
  return /*#__PURE__*/React.createElement(ProfileLinksList, null, links.map(link => /*#__PURE__*/React.createElement("li", {
    key: link
  }, /*#__PURE__*/React.createElement(Hyperlink, {
    target: "_blank",
    href: link
  }, renderSocialIcon(link)))));
};
ProfileLinks.propTypes = {
  links: arrayOf(string).isRequired
};